import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { AgentConversationService } from '../../../../services/agent-conversation.service';

@Component({
    selector: 'app-retry-button',
    templateUrl: './retry-button.component.html',
    styleUrls: ['./retry-button.component.scss'],
    standalone: true,
    imports: [MatButton, MatIcon]
})
export class RetryButtonComponent {
  @Input() disabled = false;

  constructor(private _agentConversationService: AgentConversationService) {}

  onRetry(): void {
    if (!this.disabled) {
      this._agentConversationService.retryLastRequest();
    }
  }
}
